export default function QuellePedagogie() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Quelle pédagogie</h1>
      <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
        <h3 className="font-semibold">Projet de l'école et plan d'études</h3>
        <p>La Voie Lactée a pour référence le plan d'études romand (PER) pour les classes de la 1ère à la 8ème année et accueille des élèves présentant des difficultés du domaine psychique.</p>
        <p>Notre pratique s'inspire de la Pédagogie Freinet et de la Pédagogie Institutionnelle. Nous proposons un cursus sous forme de contrats successifs individualisés, signés par l'élève, les parents et l'équipe enseignante.</p>
        <p>La classe est un lieu où les institutions médiatrices dynamisent le désir d'apprendre et organisent le travail scolaire. Le dispositif institutionnel prévient la violence et assure une place à chacun.</p>
      </div>
    </main>
  );
}
